'use client'
import { IconType } from "react-icons";
import { CustomTime, ISession, IUserData } from "./types";
import { MdApps, MdAssessment, MdAssignment, MdDirectionsCar, MdExitToApp, MdNavigation, MdPeople, MdSettings } from "react-icons/md";

export const saveSession = (session: ISession) => {
  sessionStorage.setItem('session', JSON.stringify(session));
}

export const getSession = (): ISession | null => {
  const session = sessionStorage.getItem("session") as unknown as string;
  return session && session != 'null' ? JSON.parse(session) as ISession : null;
}

export const saveToLocalStorage = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data))
}
export const getStoredUserData = (): IUserData | null => {
  const data = localStorage.getItem('user') as unknown as string;
  return data && data != null && data != 'undefined' ? JSON.parse(data) as IUserData : null

}
export const getStatusMessage = (status: number): string => {
  switch (status) {
    default:
    case 0:
      return "Pending approval";
    case 1:
      return "Pending authorization";
    case 2:
      return "Already authorized";
    case 3:
      return "Request is closed";
    case 4:
      return "Request was rejected";
    case 5:
      return "Request was cancelled";
    
  }
}
export const clearSession = () => {
  localStorage.clear();
  sessionStorage.clear();
}
export const getIcon = (text: string | IconType): IconType => {
  let icon = MdAssignment;
  switch (text) {
    case 'apps':
      icon = MdApps;
      break;
    case 'people':
      icon = MdPeople;
      break;
    case 'settings':
      icon = MdSettings;
      break;
    case 'direction_cars':
      icon = MdDirectionsCar;
      break;
    case 'navigation':
      icon = MdNavigation;
      break;
    case 'assessment':
      icon = MdAssessment;
      break;
    case 'exit_to_app':
      icon = MdExitToApp;
      break;
    case 'assignment':
    default:
      icon = MdAssignment;
  }
  return icon;
}
export const dateFormatWithTime = (seconds: number, timeOnly: boolean) => {
  let months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateObject = new Date(seconds * 1000);
  let hrs =
    dateObject.getHours() < 10
      ? "0" + dateObject.getHours()
      : dateObject.getHours();
  let mins =
    dateObject.getMinutes() < 10
      ? "0" + dateObject.getMinutes()
      : dateObject.getMinutes();
  let secs =
    dateObject.getSeconds() < 10
      ? "0" + dateObject.getSeconds()
      : dateObject.getSeconds();
  let date =
    dateObject.getDate() +
    " " +
    months[dateObject.getMonth()] +
    " " +
    dateObject.getFullYear();

  let time =
    " " +
    hrs +
    ":" +
    mins +
    ":" +
    secs;

  return timeOnly ? time : `${date}  ${time}`;
};
export const validatePhoneNumber = (phone: string): string | boolean => {
  let phoneNumber = phone ? phone.replaceAll(" ", "").replaceAll("-", "") : null;
  let validPhoneNumber: string | boolean = false;
  if (phoneNumber && phoneNumber.length > 9) {
    switch (phoneNumber.length) {
      case 10:
        validPhoneNumber = `255${phone.substr(1)}`; //trim leading 0 and prepend tz country prefix;
        break;
      case 12:
        validPhoneNumber = phoneNumber;
        break;
      case 13:
        if (phoneNumber.substr(0, 1) == '+') validPhoneNumber = phoneNumber.substr(1); //remove + sign and reassure country code
        break;
      default:
        validPhoneNumber = false;
        break;
    }
  }
  return validPhoneNumber;
};
export const dateFormat = (seconds: number): string => {
  let months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateObject = new Date(seconds * 1000);
  let date =
    dateObject.getDate() +
    " " +
    months[dateObject.getMonth()] +
    " " +
    dateObject.getFullYear();

  return date;
};

export const findTotalDistance = (collection: any[]): number => {
  let total = 0;
  collection.forEach((c) => {
    total += c.end_mileage - c.start_mileage;
  });
  return total;
};

export const findTotal = (collection: any[]): number => {
  let total = 0;
  collection.forEach((item) => {
    total += item.a_price * item.a_amount;
    // return total;
  });
  return total;
};
export const formatNumber = (num: number | string): string => {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};

export const getQueryString=(url:string):string=>{
  if(url && url.length > 4){
    const parts = url.split("?");
    if(parts.length > 1) return `?${parts[1]}`;
    return ""
  }
  return ""

}
//check if string is only white spaces
//    export const isWhiteSpaces = (string:string):boolean => {
//       if (typeof string !== "string") return false;
//       let stringArray = Array.from(string);
//       let result = stringArray.splice(
//         0,
//         stringArray.length,
//         ...new Set<string>(stringArray)
//       );
//       if (result.length == 1) return result[0] === " ";
//       return false;
//     };

export const getPositionValue = (positions: any[], id: number): any => {
  let position = positions.filter((p) => {
    return p.id === id;
  });
  return position.length > 0
    ? position[0]
    : { id: id, value: "Unknown", positions: "" };
};

//validate email address
export const validateEmail = (email: string): boolean => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
    return true;
  }

  return false;
};

//search username
export const userExists = (username: string, users: any[]): boolean => {
  let keyword = username.toLowerCase();
  users = users.filter((u) => {
    return u.username.toLowerCase().search(keyword) !== -1;
  });
  return users.length > 0;
};
//get activities
export const getActivities = (fcode: string, fundcodes: any[]): string[] => {
  if (fundcodes.length > 0) {
    let fc = fundcodes.filter((c) => {
      return c.code.toLowerCase() == fcode.toLowerCase();
    })[0];
    let activities = fc.activities.split(",");
    return activities;
  }
  return []
}

//get fundcodes from project code
export const getCodes = (project: string, fundcodes: any[]): any[] => {
  if (fundcodes.length > 0) {
    let codes = fundcodes.filter((fc) => {
      return fc.project === project;
    });
    return codes;
  } else return [];
};
export const getRequestTypeIdFromText = (text: string): number => {
  switch (text.toLowerCase()) {
    case 'vehilce':
      return 0;
    case "fuel":
      return 1;
    case 'service':
      return 2;
    case "full_service":
      return 3;
    case 'repair':
      return 4;
    default:
      return 0
  }
};
export const getRequestTypeText = (type: number) => {
  switch (type) {
    case 0:
      return "Vehicle Request";
    case 1:
      return "Fuel Request";
    case 2:
      return "Normal Car Service";
    case 3:
      return "Full Car Service";
    case 4:
      return "Repair Service";
  }
};
export const groupByArray = (xs: any[], key: any) => {
  let result = xs.reduce((rv, x) => {
    let v = key instanceof Function ? key(x) : x[key];
    let el = rv.find((r: any) => r && r.key === v);
    if (el) {
      el.values.push(x);
    } else {
      rv.push({ key: v, values: [x] });
    }
    return rv;
  }, []);

  return result;
};

export const calculateTime = (end: string, start: string): CustomTime => {
  let date = new Date();
  let endtime = dateFormat(date.getTime() / 1000) + " " + end;
  let starttime = dateFormat(date.getTime() / 1000) + " " + start;
  let endDate = new Date(endtime);
  let startDate = new Date(starttime);
  let endMilliseconds = endDate.getTime();
  let startMilliseconds = startDate.getTime();

  let diff = 0;

  if (startMilliseconds > endMilliseconds) {
    diff = (24 * 3600 * 1000 - startMilliseconds + endMilliseconds) / 1000;
  } else {
    diff = (endMilliseconds - startMilliseconds) / 1000;
  }
  const difference = diff / 3600
  let hours = parseInt(difference.toString());
  let mins = parseInt((difference / 60).toString());
  let secs = parseInt((difference % 60).toString());
  let time = { h: hours, m: mins, s: secs };

  return time;
};
export const isEmailAvailable = (users: any[], email: string): boolean => {
  let user = users.filter((u) => {
    return u.email === email;
  });
  if (user && user.length > 0) return false;
  else return true;
};

export const isAdmin = (user?: IUserData | null) => {
  if (!user) return false;
  return user.position >= 5
}